import { FC } from 'react'
import { Flex } from '@/components/atoms/Grid'
import styled from 'styled-components'
import { Tiny2 } from '@/components/atoms/typography'
import Link from '@/components/atoms/link'
import Badge from '@/components/atoms/badge'

type DesktopHeaderButtonRedesignProps = {
  title: string
  hrefLink: string
  notifyCount?: number
  IconElement: JSX.Element
  isDropdown?: boolean
  isCartButton?: boolean
} & Rest

const DesktopHeaderButtonRedesign: FC<DesktopHeaderButtonRedesignProps> = ({
  title,
  hrefLink,
  notifyCount,
  IconElement,
  children,
  isDropdown,
  isCartButton,
  ...rest
}) => (
  <>
    <Link href={hrefLink} py={11}>
      <StyledFlex isDropdown={isDropdown} {...rest}>
        {IconElement}
        <StyledTitle>{title}</StyledTitle>
        {notifyCount >= 0 && isCartButton ? (
          <StyledBadge counter={notifyCount} ml="5px" />
        ) : notifyCount ? (
          <StyledBadge counter={notifyCount} ml="5px" />
        ) : null}
      </StyledFlex>
    </Link>
    {children}
  </>
)

export default DesktopHeaderButtonRedesign

const StyledFlex = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  gap: 5px;
  &::after {
    content: '';
    background: #000;
    bottom: -6px;
    width: 0;
    height: 2px;
    left: 0;
    position: absolute;
    -webkit-transition: width 0.3s;
    -o-transition: width 0.3s;
    transition: width 0.3s;
  }
  &:hover::after {
    width: ${({ isDropdown }) => (!isDropdown ? '100%' : '0')};
  }
`

const StyledTitle = styled(Tiny2)`
  padding: 0;
  margin: 0;
  justify-content: center;
  font-size: 15px;
  line-height: 12px;
  font-weight: 400;
  color: ${(props) => props.theme.colors.towerColorSecondary};
  &:hover {
    color: ${(props) => props.theme.colors.onBackground};
  }
`

const StyledBadge = styled(Badge)`
  position: absolute;
  left: 46%;
  top: -6px;
`
